<script lang="ts">
    import * as Dialog from "$lib/components/ui/dialog";
    import Button from "@/lib/components/ui/button/button.svelte";
    import AvailabilityEditor from "./AvailabilityEditor.svelte";
    import type { Availability } from "@/Common/constants";

    // The availability editor in a modal dialog, for the planner. It goes inside a Dialog.Root with its trigger:
    //   <Dialog.Root><Dialog.Trigger>...</Dialog.Trigger><AvailabilityDialog .../></Dialog.Root>
    export let defaultAvailability: Availability
    export let id: string
    export let dowLabel: string
    // The day it is for, shown in the title ("Wed, Nov 4")
    export let dateLabel = ""
    export let medians: { duration: number, time: string, high?: boolean } | null = null
    export let scopeLabel: string | null = null
    export let scope: "day" | "weekday" = "day"
    export let resetDot: "red" | "yellow" | null = null
    export let showSave = false
    export let saveDisabled = false
</script>

<!-- Tall for a short screen only with the explanations open: then it scrolls, as a dialog does -->
<!-- The page behind stays as it is, a little dimmed: no blur -->
<Dialog.Content overlayClass="bg-black/30 backdrop-blur-none" class="box-border max-h-[95dvh] w-[calc(100vw-1.5rem)] max-w-[24rem] gap-3 overflow-y-auto p-5">
<!-- The visible title is the editor's: it follows the day or weekdays being set -->
    <Dialog.Title class="sr-only">Set your availability for {dowLabel}</Dialog.Title>
    <AvailabilityEditor {dateLabel} titleClass="whitespace-nowrap pr-6 text-base font-semibold leading-none" bind:defaultAvailability bind:scope {id} {dowLabel} {medians} {scopeLabel} {resetDot} {showSave} {saveDisabled}
        on:save on:reset on:scope>
        <svelte:fragment slot="save" let:save let:disabled>
            <Dialog.Close asChild let:builder>
                <Button builders={[builder]} size="sm" {disabled} on:click={save}>Save</Button>
            </Dialog.Close>
        </svelte:fragment>
    </AvailabilityEditor>
</Dialog.Content>
